import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress ResizeObserver loop warning (harmless, caused by MUI animations)
const resizeObserverLoopErr = /^ResizeObserver loop completed with undelivered notifications/;
const consoleError = console.error;
console.error = (...args) => {
  if (args[0] && resizeObserverLoopErr.test(args[0])) {
    return;
  }
  consoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  // You can also override other console methods like info, debug, etc.
  // console.info = () => {};
  // console.debug = () => {};
}
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
